import { render, staticRenderFns } from "./LoaderSpinner.vue?vue&type=template&id=3804a47a&scoped=true&"
import script from "./LoaderSpinner.vue?vue&type=script&lang=js&"
export * from "./LoaderSpinner.vue?vue&type=script&lang=js&"
import style0 from "./LoaderSpinner.vue?vue&type=style&index=0&id=3804a47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3804a47a",
  null
  
)

export default component.exports